// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Replace with your Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyBk-3G9p_kk0mZPR_sA15pdA182X9rm7bk",
  authDomain: "sunshine-gym-tvm.firebaseapp.com",
  projectId: "sunshine-gym-tvm",
  storageBucket: "sunshine-gym-tvm.firebasestorage.app",
  messagingSenderId: "82658680700",
  appId: "1:82658680700:web:8cfaad2849abd311b44ef9",
  measurementId: "G-R9FVMD8JFE"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
